import { Component, OnInit } from '@angular/core';
import { ExportService } from 'src/app/shared/services/export-services';
import { saveAs } from 'file-saver';
import { NotificationsService } from 'src/app/shared/notifications.service';
import { Ng7BootstrapBreadcrumbService } from 'ng7-bootstrap-breadcrumb';

@Component({
  selector: 'app-relatorios-externo',
  templateUrl: './relatorios-externo.component.html',
  styleUrls: ['./relatorios-externo.component.scss']
})
export class RelatoriosExternoComponent implements OnInit {

  isGeneratingReport = false;
  columnOptions = [
		{value: 'title', title: 'Titulo'},
		{value: 'creator', title: 'Criador'},
		{value: 'credits', title: 'Crédito'},
    {value: 'publishAs', title: 'Publicador'},
    {value: 'category', title: 'Categoria'},
    {value: 'date', title: 'Data de criação'}
  ];
  btnTitle = 'Exportar Relatório';

  constructor(
    private ng7BootstrapBreadcrumbService: Ng7BootstrapBreadcrumbService,
    private exportService: ExportService,
    private notificationService: NotificationsService
  ) { }

  ngOnInit() {
    const breadcrumbs = [
      { label: 'Sesc Digital', url: '/', params: [] },
      { label: 'Relatório de conteúdo externo', url: '', params: [] },]
	  
    this.ng7BootstrapBreadcrumbService.updateBreadcrumb(breadcrumbs);
  }

  export(form: any): void {
    let payload = {};

    if (form.searchTerm) {
      payload = {
        [form.column.value]: form.searchTerm,
      }
    } else if(form.createdDateStart && form.createdDateEnd) {
      payload = {
        createdDateStart: form.createdDateStart.format("YYYY-MM-DD"),
        createdDateEnd: form.createdDateEnd.format("YYYY-MM-DD"),
      }
    }

    this.isGeneratingReport = true;

    this.exportService.getContentExport(
      'CONTENT_TYPE_CATEGORY_SIMPLE', 'FORMAT_EXTERNAL', payload
    ).toPromise().then(
      response => {
        this.isGeneratingReport = false;
        saveAs(response.body, response.headers.get('Content-Disposition').split('=')[1]);
        this.notificationService.showSuccess('', 'Relatório gerado');
      },
      error => {
        this.isGeneratingReport = false;				
        this.notificationService.showError('Erro', 'Erro ao gerar relatório');
      }
    );
  }

}
